import gql from 'graphql-tag';

const GET_HASHED_EMAILS = gql`
  query hashedEmailLists($id: ID!) {
    hashedEmailLists(where: { id: $id }) {
      id
      name
      activated
      tag
      deviceCount
      matchRate
      isProcessedByStatera
      dspSegmentIds
      csvFileName
      status
      dsp
      stepProgress
      typeOfFirstPartyData
      createdAt
      uploadedAt
      updatedAt
      processedAt
      orgs {
        id
        name
        parentOrg {
          id
          name
        }
      }
    }
  }
`;

export default GET_HASHED_EMAILS;
